import { focusOutline } from 'shared/assets/styles';
import styled from 'styled-components';

export const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  padding: 0;
  border: none;
  background: none;
  cursor: help;
  color: ${({ theme }) => theme.palette.text.secondary};

  & > svg {
    width: 1.4rem;
    height: 1.4rem;
  }

  &:focus-visible {
    ${focusOutline};
  }
`;
